import { render, staticRenderFns } from "./WorkUploader.vue?vue&type=template&id=48ee66af&scoped=true"
import script from "./WorkUploader.vue?vue&type=script&lang=js"
export * from "./WorkUploader.vue?vue&type=script&lang=js"
import style0 from "./WorkUploader.vue?vue&type=style&index=0&id=48ee66af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ee66af",
  null
  
)

export default component.exports